import { render, staticRenderFns } from "./NewVersion.vue?vue&type=template&id=598c4c53&scoped=true&"
import script from "./NewVersion.vue?vue&type=script&lang=ts&"
export * from "./NewVersion.vue?vue&type=script&lang=ts&"
import style0 from "./NewVersion.vue?vue&type=style&index=0&id=598c4c53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598c4c53",
  null
  
)

export default component.exports